import { css } from "styled-components";
export default css`
    // Rate
    .ant-rate-star-second {
        color: #c6c6c6;   
    }
`;